import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { ICoreProductCategory } from "../types/core";

const API = process.env.REACT_APP_API;

/**
 * Hook para buscar categorias do catálogo (core.ProductCategory)
 * que têm pelo menos um produto associado à Seed da semeadora logada.
 */
const useCoreProductCategories = () => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["core_product_categories"],
    queryFn: () => {
      return fetch(`${API}/api/semeadora/core_product_categories/`, {
        method: "GET",
      }) as Promise<ICoreProductCategory[]>;
    },
    onError: (error) => {
      console.error("Erro ao carregar categorias", error);
    },
  });
};

export default useCoreProductCategories;
